// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__rms9I","Label":"Checkbox_Label__2xCdc","InputElement":"Checkbox_InputElement__LuaEA","Invalid":"Checkbox_Invalid__2WbLR"};